// extracted by mini-css-extract-plugin
module.exports = {"editor":"styles_editor__2Sdzv","slideInFromRight":"styles_slideInFromRight__2KNgm"};